import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import TopicSelectionBaseInfo from '../../../../components/topicSelection/TopicSelectionBaseInfo';
import './basicInfoModal.scss'

class BasicInfoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        }
    }

    changeVisible = (visible) => {
        this.setState({
            visible
        })
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                className="topic-basic-info"
                width="50%"
                title="基本信息"
                visible={visible}
                onCancel={() => this.changeVisible(false)}
                footer={null}>
                <div className="topic-basic-info">
                    <TopicSelectionBaseInfo data={this.props.data} />
                </div>
            </Modal>
        )
    }
}

BasicInfoModal.defaultProps = {
    data: {}
}

BasicInfoModal.propTypes = {
    data: PropTypes.object.isRequired
}


export default BasicInfoModal